import React from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { MenuItem, TextField } from "@mui/material";
import { Tickets_Severity_All, Tickets_Severity_FromId_Z524259A4, Tickets_Severity__get_Id } from "../../Shared/Shared.js";
import { map } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { Tickets_severity } from "../../Locale.js";

export function Activities_SeveritySelection_49984EA(activities_SeveritySelection_49984EAInputProps) {
    let elems;
    const onChange = activities_SeveritySelection_49984EAInputProps.onChange;
    const severity = activities_SeveritySelection_49984EAInputProps.severity;
    const ctx = reactApi.useContext(ctx_1);
    return MuiHelpers_createElement(TextField, [["fullWidth", true], ["label", ctx.Locale.t("Ticket.Severity.Severity")], ["select", true], ["value", Tickets_Severity__get_Id(severity)], ["onChange", (ev) => {
        onChange(Tickets_Severity_FromId_Z524259A4(ev.target.value));
    }], (elems = map((severity_1) => MuiHelpers_createElement(MenuItem, [["value", Tickets_Severity__get_Id(severity_1)], ["children", Tickets_severity(ctx.Locale, severity_1)]]), Tickets_Severity_All()), ["children", reactApi.Children.toArray(Array.from(elems))])]);
}

